import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { I18nService } from './i18n.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private readonly i18n = inject(I18nService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly subscription: Subscription;

  constructor() {
    this.subscription = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(value: string | number | null | undefined, params?: Record<string, string | number>): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'number' && !params) return this.i18n.formatNumber(value);
    return this.i18n.t(String(value), params);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

@Pipe({
  name: 'ln',
  standalone: true,
  pure: false
})
export class LocalNumberPipe implements PipeTransform, OnDestroy {
  private readonly i18n = inject(I18nService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly subscription: Subscription;

  constructor() {
    this.subscription = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(value: string | number | null | undefined, digitsInfo = '1.0-0'): string {
    if (value === null || value === undefined || value === '') return '';
    return this.i18n.formatNumber(value, digitsInfo);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

@Pipe({
  name: 'lcurrency',
  standalone: true,
  pure: false
})
export class LocalCurrencyPipe implements PipeTransform, OnDestroy {
  private readonly i18n = inject(I18nService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly subscription: Subscription;

  constructor() {
    this.subscription = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(value: string | number | null | undefined, currency = 'INR', digitsInfo = '1.2-2'): string {
    if (value === null || value === undefined || value === '') return '';
    return this.i18n.formatCurrency(value, currency, digitsInfo);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

@Pipe({
  name: 'ldate',
  standalone: true,
  pure: false
})
export class LocalDatePipe implements PipeTransform, OnDestroy {
  private readonly i18n = inject(I18nService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly subscription: Subscription;

  constructor() {
    this.subscription = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(value: string | number | Date | null | undefined): string {
    if (value === null || value === undefined || value === '') return '';
    return this.i18n.formatDate(value);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
